import Api from 'dash/src/services/Api';
import ExternalIdSource from '@vestahealthcare/common/models/ExternalIdSource';

export const getExternalIdSources = async (): Promise<ExternalIdSource[]> => {
  const { externalIdSources } = await Api.getv2('/external-id-sources');
  return externalIdSources.items.map((item: any) => new ExternalIdSource(item));
};
